import React from "react";
import {
  Tooltip,
  Type,
  Icon,
} from "discover.medical.react-component-library";
import { requirements } from "../password-requirements";
import "./index.css";

export const PasswordTooltip = () => {
  return (
    <div className="PasswordTooltip">
      <Tooltip
        variant="light"
        hasArrow={true}
        placement="top"
        contentSize="xs"
        toggle="click"
        content=""
        trigger={
          <Icon
            className="PasswordTooltip__icon"
            displayName="Password Info"
            icon={{ glyph: "help_outline", size: "xs" }}
          />
        }
      >
        <div className="PasswordTooltip__content">
          <Type element="h6">Password security requirements:</Type>
          <Type element="p" fontSize="xs">
            {requirements}
          </Type>
        </div>
      </Tooltip>
    </div>
  );
};

export default PasswordTooltip;
